<template>
  <div class="action-bar d-flex align-items-center justify-content-between flex-wrap mb-1">
    <div class="action-bar-left d-flex align-items-center flex-wrap" style="gap: 0.5rem;">
      <b-button
        size="sm"
        :variant="activeFiltersCount > 0 ? 'primary' : 'outline-secondary'"
        @click="$emit('toggle-filters')"
      >
        <feather-icon icon="FilterIcon" size="14" />
        <span class="ml-25">Filtros</span>
        <b-badge
          v-if="activeFiltersCount > 0"
          variant="light"
          pill
          class="ml-50"
        >
          {{ activeFiltersCount }}
        </b-badge>
      </b-button>

      <slot name="left-content"></slot>

      <div v-if="filterChips && filterChips.length" class="d-flex flex-wrap" style="gap: 0.375rem;">
        <b-badge
          v-for="(chip, index) in filterChips"
          :key="index"
          variant="light-primary"
          class="d-inline-flex align-items-center"
        >
          {{ chip.label }}
          <feather-icon
            v-if="chip.removable !== false"
            icon="XIcon"
            size="12"
            class="ml-50 cursor-pointer"
            @click="$emit('remove-chip', chip)"
          />
        </b-badge>
      </div>
    </div>

    <div class="action-bar-right d-flex align-items-center flex-wrap" style="gap: 0.5rem;">
      <slot name="right-content"></slot>

      <slot name="actions">
        <b-button
          v-if="showPrimaryAction"
          size="sm"
          variant="primary"
          :disabled="isLoading"
          @click="$emit('primary-action')"
        >
          <feather-icon :icon="primaryActionIcon" size="14" />
          <span class="ml-25">{{ primaryActionLabel }}</span>
        </b-button>
      </slot>
    </div>
  </div>
</template>

<script>
import { BButton, BBadge } from 'bootstrap-vue';

export default {
  name: 'ActionBar',
  components: { BButton, BBadge },
  props: {
    activeFiltersCount: { type: Number, default: 0 },
    filterChips: { type: Array, default: () => [] },
    isLoading: { type: Boolean, default: false },
    showPrimaryAction: { type: Boolean, default: true },
    primaryActionLabel: { type: String, default: 'Ação' },
    primaryActionIcon: { type: String, default: 'PlusIcon' },
  },
};
</script>

<style scoped>
.action-bar {
  gap: 0.75rem;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
